import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx, isRef as _isRef, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"margin":"0"} }
const _hoisted_2 = { class: "p-d-flex p-flex-wrap" }

import { useCreateCustomer } from "@/graphql/customer/create.customer";
import CustomerForm from "@/components/customer/CustomerForm.vue";
import { useCustomerPermissions } from "@/hooks/permissions/useCustomerPermission";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerCreate',
  props: {
    clas: { default: "p-button-raised p-button" }
  },
  setup(__props: any) {



const { canCreate } = useCustomerPermissions();
const { loading, dialog, form, createCustomer, resetFields } =
  useCreateCustomer();

const cannotCreate = computed(() => !canCreate || loading.value);

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Button, {
      class: _normalizeClass(_ctx.clas),
      icon: "pi pi-plus",
      label: _ctx.$t('add'),
      style: {"margin":"5px"},
      onClick: _cache[0] || (_cache[0] = ($event: any) => (dialog.value = true)),
      disabled: cannotCreate.value
    }, null, 8, ["class", "label", "disabled"]),
    _createVNode(_component_Dialog, {
      visible: _unref(dialog),
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => (_isRef(dialog) ? (dialog).value = $event : null))
    }, {
      header: _withCtx(() => [
        _createElementVNode("h5", _hoisted_1, _toDisplayString(_ctx.$t("customer.formLabel.add")), 1)
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(resetFields)())),
          class: "p-button-warning",
          icon: "pi pi-times",
          label: _ctx.$t('reset')
        }, null, 8, ["label"]),
        _createVNode(_component_Button, {
          loading: _unref(loading),
          disabled: cannotCreate.value,
          icon: "pi pi-user-plus",
          onClick: _unref(createCustomer),
          label: _ctx.$t('add')
        }, null, 8, ["loading", "disabled", "onClick", "label"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(CustomerForm, {
            name: _unref(form).name.$value,
            "onUpdate:name": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).name.$value) = $event)),
            error: _unref(form).name.$hasError,
            phone: _unref(form).phone.$value,
            "onUpdate:phone": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).phone.$value) = $event)),
            "phone-error": _unref(form).phone.$hasError,
            address: _unref(form).address.$value,
            "onUpdate:address": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).address.$value) = $event)),
            email: _unref(form).email.$value,
            "onUpdate:email": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).email.$value) = $event)),
            errorEmail: _unref(form).email.$hasError,
            onSubmit: _withModifiers(_unref(createCustomer), ["prevent"])
          }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_Button, { type: "submit" }, null, 512), [
                [_vShow, false]
              ])
            ]),
            _: 1
          }, 8, ["name", "error", "phone", "phone-error", "address", "email", "errorEmail", "onSubmit"])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})